import styled from 'styled-components';

const SelectorsWrapper = styled.div `
  padding: 16px 16px ${(props) => (props.narrow ? '8px' : '16px')};
  border-right: ${(props) => props.narrow ? 'none' : '1px solid rgba(0, 0, 0, 0.08)'};
  border-top: ${(props) => props.narrow ? '1px solid rgba(0, 0, 0, 0.08)' : 'none'};
  display: ${(props) => (props.narrow ? 'flex' : 'block')};
  overflow: auto;

  & > div {
    margin-bottom: 14px;
    div {
      white-space: nowrap;
    }
  }
`;

export { SelectorsWrapper };
